import $ from 'jquery';
$(document).ready(function () {
    $(document).on('touchend click', '[data-download-presentation-send]', function (e) {
        e.preventDefault();
        let obj = $(this);
        obj.attr('disabled', 'disabled');
        let form = obj.closest('form');
        let url = form.attr('action');

        let formData = form.serialize();
        $('[data-form-loader]').addClass('show');

        form.find('[data-input-box].error').find('[data-input-text]').html('');
        form.find('[data-input-box].error').removeClass('error');

        $.ajax({
            url: url,
            data: formData,
            dataType: 'JSON',
            type: "POST",
            processData: false,
            success: function (response) {
                window.location.href = form.attr('link')
                form[0].reset();
                setTimeout(function () {
                    $('[data-form-loader]').removeClass('show');
                }, 1300);
                $('[data-popup]').fadeOut();
            },
            error:function (response) {
                let errors = response.responseJSON.errors;
                $.each(errors, function (key, value) {
                    var searchInput = '[name="' + key + '"]';
                    form.find(searchInput).closest('[data-input-box]').find('[data-input-text]').html(value[0]);
                    form.find(searchInput).closest('[data-input-box]').addClass('error');
                });
                setTimeout(function () {
                    $('[data-form-loader]').removeClass('show');
                }, 1300);
            },
            complete:function (data) {
                obj.removeAttr('disabled');
            }
        });

        return false;
    });
});
